import React, { useState } from "react";
import "./kontakt.css";
import OfficeLoaction from "./OfficeLoaction";
import { contactSubmission } from "../Transformations/FormData";
import {
	Alert,
	AlertTitle,
	Box,
	Button,
	Modal,
	Typography,
} from "@mui/material";

export default function Kontakt() {
	const [open, setOpen] = useState(false); // Control modal visibility

	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	const [formData, setFormData] = useState({
		name: "",
		email: "",
		message: "",
	});
	const style = {
		position: "absolute",
		boxShadow:
			" 0.2rem 0.2rem 0.2rem #edf7ed,0.2rem -0.2rem 0.2rem #edf7ed,-0.2rem 0.2rem 0.2rem #edf7ed,-0.2rem -0.2rem 0.2rem #edf7ed",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		width: 400,
		bgcolor: "background.paper",
	};
	const handleChange = (event) => {
		const { name, value } = event.target;
		setFormData({ ...formData, [name]: value });
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		const emailStatus = await contactSubmission(formData);
		// console.log("emailStatus", emailStatus);
		// console.log("status", emailStatus.status);

		if (emailStatus.status == "mail_sent") {
			handleOpen();
		}

		// Clear the form fields
		setFormData({
			name: "",
			email: "",
			message: "",
		});
	};

	return (
		<div className="main-fields kontakt-page">
			<h2>Kontakt</h2>
			<div className="contact-form-address">
				<div className="contact-form">
					{/* <form
						name="contact-form"
						id="contact-form"
						onSubmit={handleSubmit}
						className="form-contact"
					>
						<div className="form-field">
							<div className="form-label">
								<label className="inline">
									Name <span className="required">*</span>
								</label>
							</div>
							<div className="form-data">
								<div className="form-input-wrapper">
									<input
										name="name"
										type="text"
										className=" "
										placeholder="Ihr Name"
										autoComplete="on"
										required
									/>
								</div>
							</div>
						</div>

						<div className="form-field">
							<div className="form-label">
								<label className="inline">
									Email <span className="required">*</span>
								</label>
							</div>
							<div className="form-data">
								<div className="form-input-wrapper">
									<input
										name="email"
										type="email"
										className=" "
										placeholder="Ihre Email-Adresse"
										required
									/>
								</div>
							</div>
						</div>

						<div className="form-field">
							<div className="form-label">
								<label className="inline">
									Nachricht <span className="required">*</span>
								</label>
							</div>
							<div className="form-data">
								<div className="form-input-wrapper">
									<textarea
										rows="5"
										cols="60"
										name="message"
										placeholder="Enter text"
										className="textarea-form"
									></textarea>
								</div>
							</div>
						</div>

						<div className="form-field">
							<button type="submit" className="button-form-contact">
								Senden
							</button>
						</div>
					</form> */}
					<form
						name="contact-form"
						id="contact-form"
						onSubmit={handleSubmit}
						className="form-contact"
					>
						<div className="form-field">
							<div className="form-label">
								<label className="inline">
									Name <span className="required">*</span>
								</label>
							</div>
							<div className="form-data">
								<div className="form-input-wrapper">
									<input
										name="name"
										type="text"
										className=" "
										placeholder="Ihr Name"
										autoComplete="on"
										required
										value={formData.name} // Bind the input value to state
										onChange={handleChange} // Update state on change
									/>
								</div>
							</div>
						</div>

						<div className="form-field">
							<div className="form-label">
								<label className="inline">
									Email <span className="required">*</span>
								</label>
							</div>

							<div className="form-data">
								<div className="form-input-wrapper">
									<input
										name="email"
										type="email"
										className=" "
										placeholder="Ihre Email-Adresse"
										required
										value={formData.email} // Bind the input value to state
										onChange={handleChange} // Update state on change
									/>
								</div>
							</div>
						</div>

						<div className="form-field">
							<div className="form-label">
								<label className="inline">
									Nachricht <span className="required">*</span>
								</label>
							</div>
							<div className="form-data">
								<div className="form-input-wrapper">
									<textarea
										rows="5"
										cols="60"
										name="message"
										placeholder="Enter text"
										className="textarea-form"
										value={formData.message} // Bind the textarea value to state
										onChange={handleChange} // Update state on change
									></textarea>
								</div>
							</div>
						</div>

						<div className="form-field">
							<button type="submit" className="button-form-contact">
								Senden
							</button>
						</div>
					</form>
				</div>
				<div className="office-address">
					<div className="contact-info">
						<ul className="contact-info">
							<li>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="20"
									height="20"
									fill="black"
									className="bi bi-telephone"
									viewBox="0 0 16 16"
								>
									<path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
								</svg>
								<span>+49 (0) 30 700 127 060</span>
							</li>
							<li>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="20"
									height="20"
									fill="black"
									className="bi bi-envelope"
									viewBox="0 0 16 16"
								>
									<path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z" />
								</svg>
								<span>info@feingeist-beratung.de</span>
							</li>
						</ul>
						<ul className="contact-info__links"></ul>
					</div>

					<div className="contact-info">
						<div className="company-hd">
							<span className="company-name">Feingeist GmbH</span>
						</div>

						<div className="office_address">
							<span className="name">Niederlassung Berlin</span>
							<p>
								Quartier Potsdamer Platz
								<br />
								Linkstraße 2 | Level 8<br />
								10785 Berlin
							</p>
						</div>
						<div className="office_address">
							<span className="name">Niederlassung Leipzig</span>
							<p>
								Thomasiusstraße 2<br />
								04109 Leipzig
							</p>
							<p></p>
						</div>
					</div>
				</div>
			</div>
			<div className="location-offices">
				<OfficeLoaction />
			</div>
			<Modal
				open={open}
				onClose={handleClose}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
			>
				<Box sx={style}>
					<Typography id="modal-modal-title" variant="h6" component="h2">
						<Alert severity="success">
							{/* <AlertTitle align="center">Nachricht gesendet</AlertTitle> */}
							<p className="p-0 m-0 text-center">
								Viele Dank für Ihre Nachricht.
							</p>
							<p className="p-0 m-0 text-center">
								Wir werden Sie schnellstmöglich kontaktieren.
							</p>
						</Alert>
					</Typography>
				</Box>
			</Modal>
		</div>
	);
}
